import { render, staticRenderFns } from "./PeakHeightFit.vue?vue&type=template&id=bc46e8bc&"
import script from "./PeakHeightFit.vue?vue&type=script&lang=js&"
export * from "./PeakHeightFit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports